var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from "prop-types";

import { DataWidget, Widget, WidgetHeader, WidgetBody, WidgetTitle, WidgetDescription, WidgetLoading, Chart, FormatMetric } from "../";
import { getGaChartByType } from "../../resources/functions/";
// import { getGaChartByType, getGaDate, getGaDays, getGaWeeks, getGaMonths } from "../../resources/functions/"

import "./AnalyticsWidget.scss";

var AnalyticsWidget = (_temp2 = _class = function (_Component) {
    _inherits(AnalyticsWidget, _Component);

    function AnalyticsWidget() {
        var _temp, _this, _ret;

        _classCallCheck(this, AnalyticsWidget);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
            values: {},
            title: undefined,
            description: undefined,
            loading: true,
            chart: undefined
        }, _this.componentDidUpdate = function (prevProps, prevState) {
            if (prevProps.report !== _this.props.report) {
                _this.getReport();
            }
        }, _this.getReport = function () {
            var _this$props = _this.props,
                report = _this$props.report,
                metric = _this$props.metric,
                dimension = _this$props.dimension,
                scope = _this$props.scope,
                type = _this$props.type,
                compare = _this$props.compare,
                stacked = _this$props.stacked,
                tooltipTitle = _this$props.tooltipTitle,
                tooltipLabel = _this$props.tooltipLabel;


            var chart = void 0;

            if (report) {
                chart = getGaChartByType(type, report, metric, dimension);
            }

            // use chart to set metric and scope

            if (chart) {
                metric = chart.metric;
                scope = scope || chart.scope || undefined;
            }

            // get id

            var id = [];

            if (metric) {
                id.push(metric.replace("ga:", ""));
            } else {
                id.push("widget");
            }

            if (scope) {
                id.push(scope);
            }

            id = id.join('.');

            // set state

            _this.setState({
                id: id,
                loading: true
            });

            if (!chart) {
                return false;
            }

            // set state

            _this.setState({
                loading: false,
                chart: _extends({}, chart, {
                    type: type,
                    compare: compare,
                    stacked: stacked,
                    tooltipTitle: tooltipTitle,
                    tooltipLabel: tooltipLabel
                })
            });
        }, _this.getSize = function () {
            var widgetSize = _this.props.widgetSize;


            if (!widgetSize) {
                return {};
            }

            var sizes = {
                "xs": 2,
                "s": 4,
                "m": 8,
                "l": 12,
                "xl": 16
            };

            var grid = widgetSize.split(":");

            var cols = grid[0];
            var rows = grid[1];

            cols = sizes[cols] || parseInt(cols);
            rows = sizes[rows] || parseInt(rows);

            return {
                cols: cols,
                rows: rows
            };
        }, _this.getMargins = function () {
            var _this$getSize = _this.getSize(),
                cols = _this$getSize.cols,
                rows = _this$getSize.rows;

            var chart = _this.state.chart;


            var margin = {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0
            };

            var offset = {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0
            };

            if (chart.type === "pie") {
                return {
                    margin: margin,
                    offset: offset
                };
            }

            var rowTop = {
                1: 24,
                2: 48,
                3: 60,
                4: 72,
                5: 84
            };

            margin.top = rows && rowTop[rows];

            if (rows > 5) {
                margin.top = rows && rowTop[5];
            }

            if (margin.top) {
                offset.top = margin.top * -1;
            }

            return {
                margin: margin,
                offset: offset
            };
        }, _this.renderChart = function () {
            var _this$props2 = _this.props,
                theme = _this$props2.theme,
                colors = _this$props2.colors;
            var chart = _this.state.chart;

            var _this$getMargins = _this.getMargins(),
                margin = _this$getMargins.margin,
                offset = _this$getMargins.offset;

            if (chart) {
                return React.createElement(Chart, _extends({}, chart, { margin: margin, offset: offset, theme: theme, colors: colors }));
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    AnalyticsWidget.prototype.componentDidMount = function componentDidMount() {
        this.getReport();
    };

    AnalyticsWidget.prototype.render = function render() {
        var _props = this.props,
            widgetSize = _props.widgetSize,
            theme = _props.theme,
            debug = _props.debug,
            url = _props.url,
            title = _props.title,
            description = _props.description,
            trending = _props.trending,
            loadingTitle = _props.loadingTitle;
        var _state = this.state,
            id = _state.id,
            values = _state.values,
            chart = _state.chart;


        var loading = this.state.loading || this.props.loading;

        if (debug) {
            return React.createElement(
                "pre",
                null,
                JSON.stringify(chart, null, 2)
            );
        }

        if (loading) {

            return React.createElement(
                Widget,
                this.props,
                React.createElement(WidgetLoading, { theme: theme, title: loadingTitle })
            );
        }

        return React.createElement(
            Widget,
            this.props,
            React.createElement(
                WidgetHeader,
                null,
                React.createElement(WidgetTitle, { title: title, url: url }),
                React.createElement(WidgetDescription, { description: description, trending: trending })
            ),
            React.createElement(
                WidgetBody,
                null,
                this.renderChart()
            )
        );
    };

    return AnalyticsWidget;
}(Component), _class.defaultProps = {
    loadingTitle: "Loading widget",
    title: "Widget",
    widgetType: "analytics",
    widgetSize: "1:2",
    report: undefined,
    metric: undefined,
    dimension: undefined,
    scope: undefined,
    type: "line",
    compare: false,
    stacked: false,
    labels: undefined,
    debug: false
}, _temp2);
AnalyticsWidget.propTypes = process.env.NODE_ENV !== "production" ? {
    loadingTitle: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    trending: PropTypes.string,
    tooltipTitle: PropTypes.string,
    tooltipLabel: PropTypes.string,
    scope: PropTypes.string
} : {};


export default AnalyticsWidget;